import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	HStack,
	Button,

} from '@chakra-ui/react'
import { InputText, Form, SelectField } from '../../../components/form'
import { fetchWrapper } from '../../../helpers';
import { LuArrowLeftCircle } from "react-icons/lu";

function Create({ getPage }) {
	const [customerList, setCustomerList] = useState([])


	const [formData, setFormData] = useState({
		account_name: '',
		customer_id: '',
		business_name: '',
		token: '',
		business_number: '',
		status_id: '',


	});

	const FormSchema = Yup.object().shape({
		account_name: Yup.string().required('Required'),
		customer_id: Yup.string().required('Required'),
		business_name: Yup.string().required('Required'),
		business_number: Yup.string().required('Required'),
		token: Yup.string().required('Required'),

	});

	useEffect(() => {
		loadCustomerList()
	}, [])


	const loadCustomerList = async () => {
		const url = `${process.env.REACT_APP_API_URL}/customer/list`;
		const response = await fetchWrapper.get(url)
		const customerList = response.data;

		const allCustomersEntry = { id: 0, name: "All Customers" };


		const updatedData = [allCustomersEntry, ...customerList];
			let data = updatedData?.map(item => ({ id: item.id, name: item.business_name || item.name }))
		const db = { data: data };
		setCustomerList(db);
	}










	const statusList = {
		data: [
			{ id: '1', name: 'Active' },
			{ id: '0', name: 'InActive' }
		]
	};


	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values
		


		const url = `${process.env.REACT_APP_API_URL}/whatsapp_api/create`;
		await fetchWrapper.post(url, data)

		getPage('list');

	}

	return (
	
			<div className="setting_detail_section">
				<HStack>
					<Box>
						<LuArrowLeftCircle style={{ fontSize: '24px', cursor: 'pointer' }} onClick={() => getPage('list')} />
					</Box>
					<Box>
						<h2 className="main_heading">WhatsApp Account</h2>
					</Box>
				</HStack>
				<Form
					enableReinitialize
					validationSchema={FormSchema}
					initialValues={formData}
					onSubmit={onSubmit}
				>


					<InputText name="account_name" title="Account Name" inputProps={{ isRequired: true }} placeholder="Please Enter Account Name" />
					<SelectField name="customer_id" title="Customers" list={customerList} isRequired />

					<InputText name="business_name" title="Business Name" inputProps={{ isRequired: true }} placeholder="Please Enter Business Name" />
					<InputText name="business_number" title="Business Number" inputProps={{ isRequired: true }} placeholder="Please Enter Business Number" />
					<InputText name="token" title="Token" inputProps={{ isRequired: true }} placeholder="Please Enter Token" />
					<Box w="30%">
						<SelectField name="status_id" title="Status" list={statusList} isRequired />
					</Box>




					<Button py="10px" px="25px" color="#fff" bg="#2563eb" fontSize="14px" fontWeight="500" fontFamily="'Open Sans', sans-serif"
						mb={4}

						type='submit'
					>
						Add WhatsApp Account
					</Button>
				</Form>
			</div>

	
	)
}

export default Create;